module.exports = {
  platform: 'voice',
  name: 'Condition',
  node: 'condition',
  bg: '#FFFFFF',
  note: '',
  property: {
    conditions: [
      {
        condition: ''
      },
      {
        condition: 'default'
      }
    ]
  }
}
